import React from 'react';
import Icon from '../../../components/AppIcon';

const AuditSummaryPanel = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="space-y-6">
        {[1, 2, 3]?.map((i) => (
          <div key={i} className="bg-card border border-border rounded-xl p-4 shadow-sm animate-pulse">
            <div className="h-5 bg-muted rounded w-1/2 mb-4"></div>
            <div className="space-y-3">
              {[1, 2, 3]?.map((j) => (
                <div key={j} className="h-12 bg-muted rounded"></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Most Active Users */}
      <div className="bg-card border border-border rounded-xl p-4 shadow-sm">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="Users" size={18} className="text-primary" />
          <h4 className="font-semibold text-foreground">Most Active Users</h4>
        </div>
        <div className="space-y-3">
          {data?.mostActiveUsers?.length === 0 ? (
            <p className="text-sm text-muted-foreground text-center py-4">No data available</p>
          ) : (
            data?.mostActiveUsers?.map((user, index) => (
              <div key={index} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg hover:bg-muted/50 transition-colors">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                    <span className="text-xs font-semibold text-primary">{index + 1}</span>
                  </div>
                  <span className="text-sm font-medium text-foreground">{user?.name}</span>
                </div>
                <span className="text-sm font-semibold text-primary">{user?.count}</span>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Frequent Actions */}
      <div className="bg-card border border-border rounded-xl p-4 shadow-sm">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="Activity" size={18} className="text-primary" />
          <h4 className="font-semibold text-foreground">Frequent Actions</h4>
        </div>
        <div className="space-y-3">
          {data?.frequentActions?.length === 0 ? (
            <p className="text-sm text-muted-foreground text-center py-4">No data available</p>
          ) : (
            data?.frequentActions?.map((action, index) => (
              <div key={index} className="space-y-1">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-foreground font-medium">{action?.action}</span>
                  <span className="text-muted-foreground">{action?.count}</span>
                </div>
                <div className="w-full bg-muted rounded-full h-2">
                  <div
                    className="bg-primary h-2 rounded-full transition-all duration-300"
                    style={{ width: `${(action?.count / data?.frequentActions?.[0]?.count) * 100}%` }}
                  ></div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Security Alerts */}
      <div className="bg-card border border-border rounded-xl p-4 shadow-sm">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="Shield" size={18} className="text-error" />
          <h4 className="font-semibold text-foreground">Security Alerts</h4>
        </div>
        <div className="space-y-3">
          {data?.securityAlerts?.length === 0 ? (
            <div className="text-center py-4">
              <Icon name="CheckCircle" size={32} className="mx-auto text-success mb-2" />
              <p className="text-sm text-success font-medium">No security alerts</p>
            </div>
          ) : (
            data?.securityAlerts?.map((alert, index) => (
              <div key={index} className="p-3 bg-error/10 border border-error/20 rounded-lg">
                <div className="flex items-start gap-2">
                  <Icon name="AlertTriangle" size={16} className="text-error mt-0.5" />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground">{alert?.action}</p>
                    <p className="text-xs text-muted-foreground mt-1">{alert?.userName}</p>
                    <p className="text-xs text-muted-foreground">{alert?.ipAddress}</p>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default AuditSummaryPanel;